import { EditOutlinedIcon, IconButton } from '@shared/components';

interface ChangeAssigneeButtonProps {
  onClick: () => void;
}

export default function ChangeAssigneeButton(props: Readonly<ChangeAssigneeButtonProps>) {
  const { onClick } = props;

  return (
    <IconButton size='small' onClick={onClick}>
      <EditOutlinedIcon
        sx={{
          width: 20,
          height: 20,
          color: (theme) => theme.palette.grey[600],
        }}
      />
    </IconButton>
  );
}
